<template>
    <div>
        <b-row>
            <b-col v-if="isSuper">
                <h2 class="text-left"><i class="fa-duotone fa-hammer fa-fw"></i> Admin Tools</h2>
                <b-row>
                    <b-col cols="2">
                        <!-- Nav -->
                        <b-form-radio-group buttons button-variant="outline-dark" size="lg" :options="devOptions" style="width: 100%;"
                                            stacked v-model="devSelection" @change="onDevSelectionChange"></b-form-radio-group>
                    </b-col>
                    <b-col cols="10">
                        <!-- Main Panel -->
                        <template v-if="devSelection === 'reset returned inventory'">
                            <b-row>
                                <b-col cols="6">
                                    <b-card bg-variant="light" header="Reset Returned Inventory">

                                        <b-form-group
                                            label="Order ID:"
                                            label-for="nested-order-id"
                                            label-cols-sm="4"
                                            label-align-sm="right"
                                        >
                                            <b-form-input id="nested-order-id" v-model.number="dev.order_id"></b-form-input>
                                        </b-form-group>

                                        <b-form-group
                                            label="Return Tracking Number:"
                                            label-for="nested-return-tracking-number"
                                            label-cols-sm="4"
                                            label-align-sm="right"
                                        >
                                            <b-form-input id="nested-return-tracking-number" v-model="dev.tracking_id"></b-form-input>
                                        </b-form-group>


                                        <b-button :disabled="dev.loading" class="float-right" v-on:click="resetInventory">
                                            <i v-if="dev.loading" class="fa-regular fa-spin fa-spinner mr-2"></i>
                                            Reset Inventory
                                        </b-button>
                                    </b-card>
                                </b-col>
                            </b-row>
                        </template>

                        <template v-if="devSelection === 'has payment queued'">
                            <b-row class="mt-2">
                                <b-col cols="2" class="text-right mt-1 text-right">
                                    Order ID:
                                </b-col>
                                <b-col>
                                    <b-form-input v-model.number="dev.order_id"></b-form-input>
                                </b-col>
                            </b-row>
                            <b-row class="mt-2">
                                <b-col class="d-flex align-items-end">
                                    <b-button :disabled="dev.loading" class="mr-0 ml-auto" v-on:click="checkForPayment">
                                        <i
                                            v-if="dev.loading" class="fa-regular fa-spin fa-spinner mr-2"></i>Check
                                        Payment
                                    </b-button>
                                </b-col>
                            </b-row>
                        </template>

                        <template v-if="devSelection === 'expedite payment'">
                            <b-row class="mt-2">
                                <b-col cols="3" class="text-right mt-1 text-right">
                                    Order ID:
                                </b-col>
                                <b-col>
                                    <b-form-input v-model.number="dev.order_id"></b-form-input>
                                </b-col>
                            </b-row>
                            <b-row class="mt-2">
                                <b-col class="d-flex align-items-end">
                                    <b-button :disabled="dev.loading" class="mr-0 ml-auto" v-on:click="expeditePayment">
                                        <i
                                            v-if="dev.loading" class="fa-regular fa-spin fa-spinner mr-2"></i>Expedite
                                        Payment
                                    </b-button>
                                </b-col>
                            </b-row>
                        </template>

                        <template v-if="devSelection === 'merge customer accounts'">
                            <b-row class="mt-2">
                                <b-col class="d-flex align-items-end">
                                    <b-button :disabled="dev.loading" class="mr-0 ml-auto" v-on:click="mergeCustomers">
                                        <i
                                            v-if="dev.loading" class="fa-regular fa-spin fa-spinner mr-2"></i>Merge
                                    </b-button>
                                </b-col>
                            </b-row>
                        </template>

                        <template v-if="devSelection === 'merge orders'">
                            <b-row class="mt-2">
                                <b-col class="d-flex align-items-end">
                                    <b-button :disabled="dev.loading" class="mr-0 ml-auto" v-on:click="mergeOrders"><i
                                        v-if="dev.loading" class="fa-regular fa-spin fa-spinner mr-2"></i>Merge
                                    </b-button>
                                </b-col>
                            </b-row>
                        </template>

                        <template v-if="devSelection === 'queue cio update'">
                            <b-row class="mt-2">
                                <b-col cols="3" class="text-right mt-1 text-right">
                                    Order ID:
                                </b-col>
                                <b-col>
                                    <b-form-input v-model.number="dev.order_id"></b-form-input>
                                </b-col>
                            </b-row>
                            <b-row class="mt-2">
                                <b-col class="d-flex align-items-end">
                                    <b-button :disabled="dev.loading" class="mr-0 ml-auto" v-on:click="queueCIOUpdate">
                                        <i
                                            v-if="dev.loading" class="fa-regular fa-spin fa-spinner mr-2"></i>Queue
                                        Update
                                    </b-button>
                                </b-col>
                            </b-row>
                        </template>

                        <template v-if="devSelection === 'queue cio sunset (end of day)'">
                            <b-row class="mt-2">
                                <b-col cols="3" class="text-right mt-1 text-right">
                                    Order ID:
                                </b-col>
                                <b-col>
                                    <b-form-input v-model.number="dev.order_id"></b-form-input>
                                </b-col>
                            </b-row>
                            <b-row class="mt-2">
                                <b-col class="d-flex align-items-end">
                                    <b-button :disabled="dev.loading" class="mr-0 ml-auto" v-on:click="queueCIOSunset">
                                        <i
                                            v-if="dev.loading" class="fa-regular fa-spin fa-spinner mr-2"></i>Begin
                                        Sunset
                                    </b-button>
                                </b-col>
                            </b-row>
                        </template>

                        <template v-if="devSelection === 'run leadsonline report'">
                            <b-row class="mt-2">
                                <b-col class="d-flex">
                                    <b-button :disabled="dev.loading" class="mr-0 ml-auto" v-on:click="runLeadsOnline">
                                        <i
                                            v-if="dev.loading" class="fa-regular fa-spin fa-spinner mr-2"></i>Run Today's LeadsOnline Report
                                    </b-button>
                                </b-col>
                            </b-row>
                        </template>

                        <template v-if="devSelection === 'run funnel etl'">
                            <b-row class="mt-2">
                                <b-col class="d-flex">
                                    <b-button :disabled="dev.loading" class="mr-0 ml-auto" v-on:click="runConversionETL">
                                        <i
                                            v-if="dev.loading" class="fa-regular fa-spin fa-spinner mr-2"></i>Run Conversion Funnel ETL <small><i>(EXPERIMENTAL)</i></small>
                                    </b-button>
                                </b-col>
                            </b-row>
                        </template>

                        <template v-if="devSelection === 'market adjustment'">
                            <b-row>
                                <b-col>
                                    <adjustment-table></adjustment-table>
                                </b-col>
                            </b-row>
                        </template>

                        <template v-if="devSelection === 'run batch report'">
                            <b-row>
                                <b-col cols="7">
                                    <b-card header="Run Batch Report" header-class="font-weight-bold">

                                        <b-form-group
                                            label="Batch Date:"
                                            label-for="nested-batch-date"
                                            label-cols-sm="4"
                                            label-align-sm="right"
                                        >
                                            <b-form-select id="nested-batch-date" v-if="dev.batchRerun.batch_list.length" v-model="dev.batchRerun.batch_id" :options="dev.batchRerun.batch_list">
                                                <template #first>
                                                    <b-form-select-option :value="null" disabled>Select a batch to rerun</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                            <template v-else>
                                                <i class="fa-solid fa-spinner fa-spin fa-lg mr-2"></i> Loading batch list...
                                            </template>
                                        </b-form-group>

                                        <b-form-group
                                            label="(Or) Batch ID:"
                                            label-for="nested-batch-id"
                                            label-cols="4"
                                            label-align-sm="right"
                                            content-cols="2"
                                        >
                                            <b-form-input id="nested-batch-id" number v-model="dev.batchRerun.batch_id"></b-form-input>
                                        </b-form-group>

                                        <b-card
                                            bg-variant="light"
                                            header="Spot Pricing Overrides"
                                            header-tag="label"
                                            sub-title="If a metal is left blank, the report will use the batch-date pricing for that metal."
                                            sub-title-tag="p">
                                            <b-row>
                                                <b-col>
                                                    <b-form-group
                                                        label="Gold"
                                                        label-for="nested-batch-id"
                                                    >
                                                        <b-input-group prepend="$">
                                                            <b-form-input id="nested-batch-id" type="text"
                                                            lazy-formatter
                                                            :formatter="$inputSanitizer.toNumeric"
                                                            v-model="dev.batchRerun.spot_price_overrides.gold"></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col>
                                                    <b-form-group
                                                        label="Silver"
                                                        label-for="nested-batch-id"
                                                    >
                                                        <b-input-group prepend="$">
                                                            <b-form-input id="nested-batch-id" type="text"
                                                            lazy-formatter
                                                            :formatter="$inputSanitizer.toNumeric"
                                                            v-model="dev.batchRerun.spot_price_overrides.silver"></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col>
                                                    <b-form-group
                                                        label="Platinum"
                                                        label-for="nested-batch-id"
                                                    >
                                                        <b-input-group prepend="$">
                                                            <b-form-input id="nested-batch-id" type="text"
                                                            lazy-formatter
                                                            :formatter="$inputSanitizer.toNumeric"
                                                            v-model="dev.batchRerun.spot_price_overrides.platinum"></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col>
                                                    <b-form-group
                                                        label="Palladium"
                                                        label-for="nested-batch-id"
                                                    >
                                                        <b-input-group prepend="$">
                                                            <b-form-input id="nested-batch-id" type="text"
                                                            lazy-formatter
                                                            :formatter="$inputSanitizer.toNumeric"
                                                            v-model="dev.batchRerun.spot_price_overrides.palladium"></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>


                                        </b-card>

                                        <b-button :disabled="dev.loading" class="float-right" v-on:click="runBatchReport">
                                            <i v-if="dev.loading" class="fa-regular fa-spin fa-spinner mr-2"></i>
                                            Run Report
                                        </b-button>
                                    </b-card>
                                </b-col>
                            </b-row>
                        </template>

                    </b-col>
                </b-row>
            </b-col>
        </b-row>


        <template v-if="devSelection === 'read event logs'">
            <b-row>
                <b-col cols="4">
                    <b-row class="mt-2">
                        <b-col cols="3" class="text-right mt-1 text-right">
                            Order ID:
                        </b-col>
                        <b-col>
                            <b-form-input v-model.number="dev.order_id"></b-form-input>
                        </b-col>
                    </b-row>
                    <b-row class="mt-2">
                        <b-col class="d-flex align-items-end">
                            <b-button :disabled="dev.loading" class="mr-0 ml-auto" v-on:click="getEventLogs"><i
                                v-if="dev.loading" class="fa-regular fa-spin fa-spinner mr-2"></i>Get Event Logs
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row>
                <b-col v-if="eventLogs" class="pt-2">

                    <b-row cols="12">
                        <b-table striped hover responsive table-variant="light" head-variant="light"
                                 caption-html="<h5>Visitor Sources</h5>" caption-top
                                 thead-class="_nowrap" :fields="visitorSourcesFields" :items="visitorSources"
                                 class="font-xs">
                            <template #cell(id_info)="data">
                                <div class="_nowrap font-xxs"><strong>ID:</strong> {{ data.item.id }}</div>
                                <div class="_nowrap font-xxs"><strong>VD:</strong> {{ data.item.visitor_device_id }}
                                </div>
                                <div class="_nowrap font-xxs"><strong>VDD:</strong> {{
                                        data.item.visitor_device_data_id
                                    }}
                                </div>
                            </template>
                            <template #cell(lp_path)="data">
                                <span class="text-monospace">{{ data.value }}</span>
                            </template>
                            <template #cell(lp_query_string)="data">
                                <span class="text-monospace">{{ data.value }}</span>
                            </template>
                            <template #cell(attribution_models)="data">
                                <i v-if="getVisitorSourcesHasAttribution(data.value, 'first_interaction')"
                                   class="fa-solid fa-play fa-lg fa-fw mr-1 text-primary" v-b-tooltip.hover
                                   title="First Interaction"></i>
                                <i v-if="getVisitorSourcesHasAttribution(data.value, 'last_interaction')"
                                   class="fa-solid fa-stop fa-lg fa-fw mr-1 text-warning" v-b-tooltip.hover
                                   title="Last Interaction"></i>
                                <i v-if="getVisitorSourcesHasAttribution(data.value, 'last_ppc_click')"
                                   class="fa-solid fa-magnifying-glass-arrow-right fa-lg fa-fw mr-1 text-success"
                                   v-b-tooltip.hover title="Last PPC Click"></i>
                                <i v-if="getVisitorSourcesHasAttribution(data.value, 'last_non_direct_click')"
                                   class="fa-solid fa-link-simple fa-lg fa-fw mr-1 text-info" v-b-tooltip.hover
                                   title="Last Non-Direct Click"></i>
                            </template>
                        </b-table>
                    </b-row>

                    <b-row cols="12" class="pt-2">
                        <b-table striped hover responsive table-variant="light" head-variant="light"
                                 caption-html="<h5>Event Logs</h5>" caption-top
                                 thead-class="_nowrap" :fields="eventLogsFields" :items="eventLogs" class="font-xs"
                                 :tbody-tr-class="getEventLogRowClass" v-on:row-clicked="eventLogShowBody">
                            <template #head(body)="data">
                                {{ data.label }}
                                <b-button size="sm" variant="link"
                                          @click="evenLogsShowAllBodies = !evenLogsShowAllBodies"><i
                                    class="fa-solid fa-fw"
                                    :class="[evenLogsShowAllBodies ? 'fa-minus-circle' : 'fa-plus-circle']"></i>
                                </b-button>
                            </template>

                            <template #cell(type)="data">
                                <span class="font-weight-bold">{{ data.value }}</span>
                            </template>
                            <template #cell(event_date)="data">
                                <span
                                    style="word-break: keep-all; overflow-wrap: break-word; white-space: break-spaces;">{{
                                        data.value
                                    }}</span>
                            </template>
                            <template #cell(body)="data">
                                <b-button size="sm" variant="link" @click="data.item.showBody = !data.item.showBody"><i
                                    class="fa-solid fa-fw"
                                    :class="[data.item.showBody ? 'fa-minus-circle' : 'fa-plus-circle']"></i></b-button>

                                <strong>Page: </strong><span
                                class="text-monospace">{{ JSON.parse(data.value).landing_page }}</span>
                                <i class="fa-solid fa-ellipsis-vertical fa-fw"></i>
                                <strong>UTM Source: </strong><span class="text-monospace text-primary font-weight-bold">{{
                                    JSON.parse(data.value).utm_source
                                }}</span>
                                <i class="fa-solid fa-ellipsis-vertical fa-fw"></i>
                                <strong>UTM Medium: </strong><span class="text-monospace text-primary font-weight-bold">{{
                                    JSON.parse(data.value).utm_medium
                                }}</span>

                                <transition name="slide-fade">
                                    <div :id="data.item.id + '-bodyDetails'"
                                         v-show="data.item.showBody || evenLogsShowAllBodies">
                                        <div class="text-monospace font-xs"
                                             style="overflow-wrap: break-word; word-break: break-all;"
                                             v-for="(data, index) in getEventLogBodyArray(data.value)">
                                            <strong>{{ index }}:</strong> {{ data }}
                                        </div>
                                    </div>
                                </transition>
                            </template>
                        </b-table>
                    </b-row>

                </b-col>
            </b-row>
        </template>

    </div>
</template>

<script>
import { BFormInput } from 'bootstrap-vue';
import AdjustmentTable from './market-table';

export default {
    name: 'admintools-index',
    title: 'Admin-Tools',
    components: {AdjustmentTable},
    data() {
        return {
            'isSuper': false,
            'devOptions': [
                {value: 'reset returned inventory', html: '<i class="fa-duotone fa-box-open-full fa-fw"></i> Reset Returned Inventory'},
                {value: 'has payment queued', html: '<i class="fa-duotone fa-money-check-dollar fa-fw"></i> Order Has Payment Queued'},
                {value: 'expedite payment', html: '<i class="fa-duotone fa-money-bill-1-wave fa-fw"></i> Expedite Payment'},
                //{ value: 'merge customer accounts', text: 'Merge Customer Accounts' },
                //{ value: 'merge orders', text: 'Merge Orders' },
                {value: 'queue cio update', html: '<i class="fa-duotone fa-message-arrow-up fa-fw"></i> Queue CIO Update'},
                {value: 'queue cio sunset (end of day)', html: '<i class="fa-duotone fa-sunset fa-fw"></i> Queue CIO Sunset (EOD)'},
                {value: 'market adjustment', html: '<i class="fa-duotone fa-money-bill-trend-up fa-fw"></i> Edit Market Adjustment'},
                {value: 'read event logs', html: '<i class="fa-duotone fa-list-timeline fa-fw"></i> Read Event Logs'},
                {value: 'run leadsonline report', html: '<i class="fa-duotone fa-list-timeline fa-fw"></i> LeadsOnline'},
                // {value: 'run funnel etl', html: '<i class="fa-duotone fa-list-timeline fa-fw"></i> Conversion ETL'},
                {value: 'run batch report', html: '<i class="fa-duotone fa-file-chart-column fa-fw"></i> Run Batch Report'},
            ],
            'devSelection': null,
            'dev': {
                'order_id': null,
                'tracking_id': null,
                'loading': false,
                'batchRerun': {
                    'batch_id': null,
                    'batch_list': [],
                    'spot_price_overrides': {
                        'gold': null,
                        'silver': null,
                        'platinum': null,
                        'palladium': null,
                    }
                }
            },
            eventLogsFields: ['id', 'type', 'event_date', 'visitor_token', 'body'],
            eventLogs: null,
            evenLogsShowAllBodies: false,
            visitorSourcesFields: ['id_info', 'channel', 'source', 'attribution_models', 'lp_path', 'criterion_1', 'criterion_2', 'criterion_3', 'criterion_4', 'lp_query_string', 'hits', 'last_visit', 'created'],
            visitorSources: null,
        };
    },
    created() {
        this.isSuper = this.$store.getters.hasRole('Super Admin');
    },
    mounted() {

    },
    beforeDestroy() {

    },
    methods: {
        onDevSelectionChange() {
            // Reset all dev inputs when changing tools
            this.dev.order_id = null;
            this.dev.tracking_id = null;
            this.dev.batchRerun.batch_id = null;
            this.dev.batchRerun.spot_price_overrides.gold = null;
            this.dev.batchRerun.spot_price_overrides.silver = null;
            this.dev.batchRerun.spot_price_overrides.platinum = null;
            this.dev.batchRerun.spot_price_overrides.palladium = null;

            switch (this.devSelection) {
                case 'reset returned inventory':
                    break;
                case 'has payment queued':
                    break;
                case 'expedite payment':
                    break;
                case 'merge customer accounts':
                    break;
                case 'merge orders':
                    break;
                case 'queue cio update':
                    break;
                case 'queue cio sunset (end of day)':
                    break;
                case 'read event logs':
                    break;
                case 'run leadsonline report':
                    break;
                case 'run funnel etl':
                    break;
                case 'market adjustment':
                    break;
                case 'run batch report':
                    this.getBatchList();
                    break;
            }
        },
        getBatchList() {
            if (this.dev.batchRerun.batch_list.length) return; // Don't re-query if we already have batches

            let optionsNoTime = {year: 'numeric', month: 'numeric', day: 'numeric'};
            this.$http.get('/batch/old?backdate=60').then((data) => {
                if (data && data.data.oldBatches) {
                    _.forEach(data.data.oldBatches, (e, i) => {
                        let date = new Date(e.closed_at);
                        this.dev.batchRerun.batch_list.push({value: e.id, text: (i === 0 ? 'Latest ' : '') + 'Batch ' + e.id + ' - ' + new Intl.DateTimeFormat('en-US', optionsNoTime).format(date)});
                    });
                }
            });
        },


        // Tool Methods
        resetInventory() {
            this.dev.loading = true;
            this.$http.post('/debug/resetReturnedInventory', {
                tracking_id: this.dev.tracking_id,
                order_id: this.dev.order_id
            }).then((data) => {
                if (data.data && data.data.success) {
                    this.$bvModal.msgBoxOk('Successfully reverted returned.', {
                        title: data.data.success ? 'Message' : 'API Issue',
                        id: 'alert_id',
                        size: 'md',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        headerClass: 'p-2 border-bottom-0 text-center d-block',
                        footerClass: 'p-2 border-top-0',
                    });
                } else if (data.data && data.data.reason) {
                    this.$bvModal.msgBoxOk(data.data.reason, {
                        title: data.data.success ? 'Message' : 'API Issue',
                        id: 'alert_id',
                        size: 'md',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        headerClass: 'p-2 border-bottom-0 text-center d-block',
                        footerClass: 'p-2 border-top-0',
                    });
                }
                this.dev.loading = false;
            });
        },
        checkForPayment() {
            this.dev.loading = true;
            this.$http.post('/debug/getPaymentsWaiting', {
                order_id: this.dev.order_id
            }).then((data) => {
                if (data && data.data.message) {
                    this.$bvModal.msgBoxOk(data.data.message, {
                        title: data.data.success ? 'Message' : 'API Issue',
                        id: 'alert_id',
                        size: 'md',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        headerClass: 'p-2 border-bottom-0 text-center d-block',
                        footerClass: 'p-2 border-top-0',
                    });
                }
                this.dev.loading = false;
            });
        },
        expeditePayment() {
            this.dev.loading = true;
            this.$http.post('/debug/forceProcessPayment', {
                order_id: this.dev.order_id
            }).then((data) => {
                if (data && data.data.message) {
                    this.$bvModal.msgBoxOk(data.data.message, {
                        title: data.data.success ? 'Message' : 'API Issue',
                        id: 'alert_id',
                        size: 'md',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        headerClass: 'p-2 border-bottom-0 text-center d-block',
                        footerClass: 'p-2 border-top-0',
                    });
                }
                this.dev.loading = false;
            });
        },
        mergeCustomers() {
            this.dev.loading = true;
            this.$http.post('/debug/mergeCustomers', {
                order_id: this.dev.order_id
            }).then((data) => {
                if (data && data.data.message) {
                    this.$bvModal.msgBoxOk(data.data.message, {
                        title: data.data.success ? 'Message' : 'API Issue',
                        id: 'alert_id',
                        size: 'md',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        headerClass: 'p-2 border-bottom-0 text-center d-block',
                        footerClass: 'p-2 border-top-0',
                    });
                }
                this.dev.loading = false;
            });
        },
        mergeOrders() {
            this.dev.loading = true;
            this.$http.post('/debug/mergeOrders', {
                order_id: this.dev.order_id
            }).then((data) => {
                if (data && data.data.message) {
                    this.$bvModal.msgBoxOk(data.data.message, {
                        title: data.data.success ? 'Message' : 'API Issue',
                        id: 'alert_id',
                        size: 'md',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        headerClass: 'p-2 border-bottom-0 text-center d-block',
                        footerClass: 'p-2 border-top-0',
                    });
                }
                this.dev.loading = false;
            });
        },
        queueCIOUpdate() {
            this.dev.loading = true;
            this.$http.post('/debug/forceCIOUpdate', {
                order_id: this.dev.order_id
            }).then((data) => {
                if (data && data.data.message) {
                    this.$bvModal.msgBoxOk(data.data.message, {
                        title: data.data.success ? 'Message' : 'API Issue',
                        id: 'alert_id',
                        size: 'md',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        headerClass: 'p-2 border-bottom-0 text-center d-block',
                        footerClass: 'p-2 border-top-0',
                    });
                }
                this.dev.loading = false;
            });
        },
        queueCIOSunset() {
            this.dev.loading = true;
            this.$http.post('/debug/forceSunset', {
                order_id: this.dev.order_id
            }).then((data) => {
                if (data && data.data.message) {
                    this.$bvModal.msgBoxOk(data.data.message, {
                        title: data.data.success ? 'Message' : 'API Issue',
                        id: 'alert_id',
                        size: 'md',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        headerClass: 'p-2 border-bottom-0 text-center d-block',
                        footerClass: 'p-2 border-top-0',
                    });
                }
                this.dev.loading = false;
            });
        },
        getEventLogs() {
            this.dev.loading = true;
            this.$http.get('/debug/getEventLogs/' + this.dev.order_id).then((data) => {
                if (data) {
                    this.eventLogs = data.data.eventLogs;
                    this.visitorSources = data.data.visitorSources;
                }
                this.eventLogs.forEach(eventLog => {
                    this.$set(eventLog, 'showBody', false);
                });
                this.dev.loading = false;
            });
        },
        getEventLogBodyArray(body) {
            return JSON.parse(body);
        },
        getEventLogRowClass(item, type) {
            if (!item || type !== 'row') return;
            switch (item.type) {
                case 'formStarted':
                    return 'table-warning';
                case 'formModified':
                    return 'table-info';
                case 'formSubmitted':
                case 'leadSubmitted':
                    return 'table-success';
                default:
                    return '';
            }
        },
        eventLogShowBody(item) {
            item.showBody = !item.showBody;
        },
        getVisitorSourcesHasAttribution(value, attribution) {
            return value.toString().includes(attribution);
        },
        runLeadsOnline() {
            this.dev.loading = true;
            this.$http.get('/debug/runLeadsOnline').then((data) => {
                if (data && data.data.message) {
                    this.$bvModal.msgBoxOk(data.data.message, {
                        title: data.data.success ? 'Message' : 'API Issue',
                        id: 'alert_id',
                        size: 'md',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        headerClass: 'p-2 border-bottom-0 text-center d-block',
                        footerClass: 'p-2 border-top-0',
                    });
                }
                this.dev.loading = false;
            });
        },
        runConversionETL() {
            this.dev.loading = true;
            this.$http.get('/debug/runConversionETL').then((data) => {
                if (data && data.data.message) {
                    this.$bvModal.msgBoxOk(data.data.message, {
                        title: data.data.success ? 'Message' : 'API Issue',
                        id: 'alert_id',
                        size: 'md',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        headerClass: 'p-2 border-bottom-0 text-center d-block',
                        footerClass: 'p-2 border-top-0',
                    });
                }
                this.dev.loading = false;
            })
            .finally(() => {
                this.dev.loading = false;
            });
        },
        runBatchReport() {
            this.dev.loading = true;
            this.$http.get('/batch/' + this.dev.batchRerun.batch_id + '/batchReport', {
                params: {
                    gold: this.dev.batchRerun.spot_price_overrides.gold,
                    silver: this.dev.batchRerun.spot_price_overrides.silver,
                    platinum: this.dev.batchRerun.spot_price_overrides.platinum,
                    palladium: this.dev.batchRerun.spot_price_overrides.palladium,
                }
            }).then(() => {
                this.$bvModal.msgBoxOk('The file will take 3-5 minutes to generate, and will be sent via email when complete.', {
                    title: 'Batch report is generating.',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    headerClass: 'p-2 border-bottom-0',
                    footerClass: 'p-2 border-top-0',
                    centered: true
                });
            })
            .finally(() => {
                this.dev.loading = false;
            });
        },
    }
};

</script>

<style scoped>
>>> label {
    font-size: 0.75rem !important;
    text-transform: unset !important;
}

>>> ._nowrap {
    white-space: nowrap;
}

.slide-fade-enter-active {
    transition: all .3s ease;
}

.slide-fade-leave-active {
    transition: all .3s ease;
}

.slide-fade-enter, .slide-fade-leave-to {
    transform: translateY(-10px);
    opacity: 0;
}

>>> .btn-group-vertical > .btn {
    text-align: left;
}

</style>
